/* eslint-disable import/prefer-default-export */

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const TOGGLE_TUTORIAL_MODAL = 'TOGGLE_TUTORIAL_MODAL';
export const TOGGLE_PROJECT_IMAGES_MODAL = 'TOGGLE_PROJECT_IMAGES_MODAL';
export const TOGGLE_MOBILE_COUPON = 'TOGGLE_MOBILE_COUPON';
export const TOGGLE_MOBILE_SIDEBAR = 'TOGGLE_MOBILE_SIDEBAR';
export const TOGGLE_MOBILE_PROJECT_INFO = 'TOGGLE_MOBILE_PROJECT_INFO';
export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';
export const SAVE_PURCHASE = 'SAVE_PURCHASE';
export const CREATING_PURCHASE = 'CREATING_PURCHASE';
export const RESET_PURCHASE = 'RESET_PURCHASE';
export const ADD_TO_PLOTCART = 'ADD_TO_PLOTCART';
export const REMOVE_FROM_PLOTCART = 'REMOVE_FROM_PLOTCART';
export const MASS_ASSIGN_PLOTCART = 'REPLACE_PLOTCART';
export const UPDATE_PLOT = 'UPDATE_PLOT';
export const CLEAR_CART = 'CLEAR_CART';
export const TOGGLE_PURCHASE_SIDEBAR = 'TOGGLE_PURCHASE_SIDEBAR';
export const UPDATE_PURCHASE = 'UPDATE_PURCHASE';
export const SET_PROJECTS = 'SET_PROJECTS';
export const SET_RANDOM_DIST_PROJECTS = 'SET_RANDOM_DIST_PROJECTS';
export const SET_PROJECTS_WITH_AREAS = 'SET_PROJECTS_WITH_AREAS';
export const SET_AREAS = 'SET_AREAS';
export const RESET_AREAS = 'RESET_AREAS';
export const SET_FACES = 'SET_FACES';
export const SET_BOUNDS = 'SET_BOUNDS';
export const SET_CURRENT_ZOOM = 'SET_CURRENT_ZOOM';
export const SET_LIMIT = 'SET_LIMIT';
export const SET_ACTIVE_PROJECT_ID = 'SET_ACTIVE_PROJECT_ID';
export const SET_CURRENT_AREA_ID = 'SET_CURRENT_AREA_ID';
export const FOCUS_ON_PROJECT = 'FOCUS_ON_PROJECT';
export const FOCUS_ON_PROJECT_DONE = 'FOCUS_ON_PROJECT_DONE';
export const SAVE_COUPON = 'SAVE_COUPON';
export const RESET_COUPON = 'RESET_COUPON';
export const SET_MAP_CENTER = 'SET_MAP_CENTER';
export const SET_INITIAL_PROJECT = 'SET_INITIAL_PROJECT';
export const SET_WHITELABELED_PROJECT = 'SET_WHITELISTED_PROJECT';
export const SET_WHITELABELED_FOUNDATION = 'SET_WHITELISTED_FOUNDATION';
export const SET_FOUNDATION = 'SET_FOUNDATION';
export const SET_PROJECT_GROUPS = 'SET_PROJECT_GROUPS';
export const TOGGLE_GROUP = 'TOGGLE_GROUP';
export const EXCHANGING_PURCHASE = 'EXCHANGING_PURCHASE';
export const CREATE_ALARM = 'CREATE_ALARM';
export const DESTROY_ALARM = 'DESTROY_ALARM';
export const UPDATE_CHECK = 'UPDATE_CHECK';
